/* eslint-disable no-sequences */
/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import axios from "axios";
import dot from 'dot-object';
import deepmerge from 'deepmerge';
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { message, Select } from 'antd';
import React, { useState, useEffect, createRef } from "react";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getInputProp } from "../../../../../screens/Edit/helper";
import { filterSelectOptions } from 'datastake-daf/src/helpers/Forms';
import { propHasValue } from "../../../../DynamicFormNew/helper";
import { getPopupContainer } from '../../../../../helpers/popUp';
import { getMainApiUrl, getAppHeader } from '../../../../../services/BaseService';

const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;

function AjaxSelect({
  authentication: { user },
  props = {},
  formsValue = {},
  call = null,
  value = null,
  repeatIndex = null,
  repeatValues = null,
  mainForm,
  onNewSetValue = null,
  multiple = false,
  updateOptions = false,
  label = '',
  unique = null,
  name = null,
  inputName = null,
  allowClear = false,
  onChange = () => { },
  onOptions = () => { }
}) {
  const endpoint = `${getMainApiUrl()}/query/options`;

  const { t } = useTranslation();
  const inst = createRef();
  const [modelValue, setModelValue] = useState(value ? value : (multiple ? [] : null));
  const [model, setModel] = useState([]);
  const [latestValue, setLatestValue] = useState(null);
  const [entity, method, mapper, updateOtherValues] = call.split('::');
  const filters = method.split(/\(/).length > 1
    ? JSON.parse(method.split(/\(/)[1].split(/\)/)[0]) : '';
  const [searchValue, setSearchValue] = useState(value);
  const [lastFilters, setLastFilters] = useState({});
  const [isFetchWithThisFilter, setIsFetchWithThisFilter] = useState(false);

  useEffect(() => {
    if (value === 'new') {
      if (!model.find(m => m.value === 'new')) {
        setModel(model.concat({ label: searchValue || t('New'), value: 'new' }))
        if (updateOptions) {
          onOptions(model.concat({ label: searchValue || t('New'), value: 'new' }));
        }
      }
    }
    setModelValue(value ? value : (multiple ? [] : null));
    setSearchValue(value);
    updateLabel(model, value);
  }, [value]);

  useEffect(() => {
    const filterValues = pickFilterValue();
    if ((Object.keys(filters).length
      && Object.keys(formsValue).length
      && hasChangedDependent() && searchValue) || (searchValue && !isFetchWithThisFilter) || !_.isEqual(filterValues, lastFilters)) {
      setLastFilters(filterValues);
      axios.post(endpoint, {
        entity,
        method: typeof filterValues === 'object'
          ? method.split(/\(/)[0]
          : method,
        mapper: JSON.parse(mapper),
        filters: filterValues,
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        },
      }).then(({ data }) => {
        if (modelValue === 'new') {
          const newData = model.find(m => m.value === 'new');
          data = data.concat([newData || { label: searchValue || t('New'), value: 'new' }]);
        } else {
          updateLabel(data, undefined);
          setTimeout(() => {
            updateLabel(data, modelValue);
          }, 100)
        }
        setModel(data);
        if (updateOptions) {
          const oldModelValue = modelValue;
          onOptions(data);
          setTimeout(() => {
            setModelValue(oldModelValue);
            onChange(oldModelValue, data || []);
          }, 10);
        }
        if (multiple) {
          if (Array.isArray(modelValue) && modelValue.length > 0) {
            const option = data.find(o => modelValue.includes(o.value));
            if (!option) {
              setModelValue([]);
              setSearchValue(null);
              onChange([], data || []);
            }
          }
        } else {
          const option = data.find(o => o.value === modelValue);
          if (!option && modelValue) {
            setModelValue(null);
            setSearchValue(null);
            onChange(undefined, data || []);
          }
        }
        setIsFetchWithThisFilter(true);
      }).catch((e) => {
        console.log(e);
      });
    }
  }, [formsValue, repeatValues, searchValue]);

  const pickFilterValue = () => {
    if (mainForm && typeof mainForm.getFieldsValue === 'function') {
      formsValue = deepmerge(formsValue || {}, mainForm.getFieldsValue() || {}, { arrayMerge: overwriteMerge });
      if (propHasValue(repeatIndex)) {
        const formList = mainForm.getFieldsValue(name);
        if (formList && formList[repeatIndex]) {
          repeatValues = formList[repeatIndex];
        }
      }
    }
    setLatestValue(formsValue);
    return Object.keys(filters).reduce((f, a) => {
      if (filters[a].split('/').length > 1) {
        const filter = filters[a].split('/')[1];
        const [objField, transform] = filter.split(/( as )/gmi);
        if (transform && transform.trim() !== '') {
          f[a] = objField
        } else if (dot.pick(objField, repeatValues)) {
          f[a] = dot.pick(objField, repeatValues);
        }
      } else {
        const [objField, transform] = filters[a].split(/( as )/gmi);
        if (transform && transform.trim() !== '') {
          f[a] = objField
        } else if (dot.pick(objField, formsValue)) {
          f[a] = dot.pick(objField, formsValue);
        } else if (dot.pick(objField, repeatValues)) {
          f[a] = dot.pick(objField, repeatValues);
        }
      }
      return f;
    }, {});
  }
  const updateLabel = (data, val) => {
    const selectedValue = data.find(d => d.value === val);
    if (selectedValue && onNewSetValue) {
      if (repeatIndex !== null && repeatValues) {
        repeatValues[onNewSetValue] = selectedValue.label;
        if (!formsValue[name]) {
          formsValue[name] = [];
        }
        formsValue[name][repeatIndex] = repeatValues;
        mainForm.setFieldsValue({ [name]: formsValue[name] });
        mainForm.scrollToField([name, repeatIndex, onNewSetValue]);
      } else {
        mainForm.setFieldsValue({ [onNewSetValue]: selectedValue.label });
        mainForm.scrollToField(onNewSetValue);
      }
    }
  }
  const hasChangedDependent = () => {
    if (mainForm && typeof mainForm.getFieldsValue === 'function') {
      formsValue = deepmerge(formsValue || {}, mainForm.getFieldsValue() || {}, { arrayMerge: overwriteMerge });
    }
    return Object.keys(filters).map(a => {
      if (dot.pick(filters[a], formsValue)) {
        return dot.pick(filters[a], formsValue) === dot.pick(filters[a], latestValue);
      } else if (dot.pick(filters[a], repeatValues)) {
        return dot.pick[filters[a], repeatValues] === dot.pick(filters[a], latestValue);
      }
      return null;
    }).includes(false);
  };
  const addNewData = (oldValue) => {
    if (onNewSetValue) {
      if (repeatIndex !== null && repeatValues) {
        repeatValues[inputName] = 'new';
        repeatValues[onNewSetValue] = oldValue;
        if (!formsValue[name]) {
          formsValue[name] = [];
        }
        formsValue[name][repeatIndex] = repeatValues;
        mainForm.setFieldsValue({ [name]: formsValue[name] });
        mainForm.scrollToField([name, repeatIndex, onNewSetValue]);
      } else {
        mainForm.setFieldsValue({ [onNewSetValue]: oldValue });
        mainForm.scrollToField(onNewSetValue);
      }
    }
    const newModelInd = model.findIndex(m => m.value === 'new');
    let newModel = { label: oldValue, value: 'new' };
    if (newModelInd >= 0) {
      model[newModelInd] = newModel;
    } else {
      model.push(newModel);
    }

    setModel([...model]);
    if (updateOptions) {
      onOptions(model.concat({ label: oldValue || t('New'), value: 'new' }));
    }
    setModelValue('new');
    inst.current.blur();
    onChange('new', model || []);
  }

  function updateOther(item) {
    try {
      const updateOtherVal = JSON.parse(updateOtherValues);
      if (updateOtherVal && Array.isArray(updateOtherVal) && updateOtherVal.length) {
        updateOtherVal.forEach(key => {
          if (repeatIndex !== null && repeatValues) {
            repeatValues[key] = item[key];
            if (!formsValue[name]) {
              formsValue[name] = [];
            }
            formsValue[name][repeatIndex] = repeatValues;
            mainForm.setFieldsValue({ [name]: formsValue[name] });
          } else {
            mainForm.setFieldsValue({ [key]: item[key] });
          }
        })
      }
    } catch {

    }

  }

  const validateSelection = (value, item, setValue = false) => {
    if (item && (item.users || formsValue.preSelected)) {
      const isSelected = formsValue && formsValue.preSelected && Array.isArray(formsValue.preSelected) && formsValue.preSelected.includes(value) ? true : false;
      const isIdentified = unique && item.users && item.users.includes(user?.company?.id) ? true : false;
      if (isIdentified && !isSelected) {
        message.error(unique);
        inst.current.focus();
      } else if (isSelected) {
        message.error(t('You have already provided this information for this question.'));
        inst.current.focus();
      } else {
        onChange(value, model || [])
        updateLabel(model, undefined);
        setTimeout(() => {
          updateLabel(model, value);
        }, 100)

        updateOther(item);
        if (setValue) {
          setModelValue(value);
        }
      }
    } else {
      onChange(value, model || [])
      updateLabel(model, undefined);
      setTimeout(() => {
        updateLabel(model, value);
      }, 100)
      updateOther(item);
      if (setValue) {
        setModelValue(value);
      }
    }
    if (!value) {
      setModel([
        ...(model || []).filter(m => m.value !== 'new')
      ])
    }
  }
  return (
    <div className="flex-c row-item">
      <label className="label">{label}</label>
      <Select
        {...getPopupContainer()}
        autoComplete="new-password"
        size="large"
        allowClear={allowClear}
        ref={inst}
        {...props}
        placeholder={getInputProp(props.placeholder, formsValue)}
        showSearch
        className="custom-select white"
        value={modelValue}
        {...multiple ? { mode: "multiple" } : {}}
        filterOption={filterSelectOptions}
        optionFilterProp="label"
        options={model || []}
        dropdownRender={(origin) => {
          return <div>
            {origin}
            {
              onNewSetValue !== false &&
                origin &&
                origin.props &&
                origin.props.options &&
                Array.isArray(origin.props.options) &&
                origin.props.options.length > 0 &&
                (model || []).filter(m => m.value === 'new' && m.label === searchValue).length === 0 ? null : null}
          </div>;
        }}
        onKeyDown={(ev) => {
          if ([9, 13].includes(ev.keyCode) && onNewSetValue) {
            const value = ev.target.value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            const option = model.find(o => {
              const stringOption = o && o.label ? o.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "") : '';
              return o.label && stringOption.indexOf(value) === 0;
            });
            if (option) {
              validateSelection(option.value, option, true);
            } else {
              addNewData(ev.target.value);
            }
          }
        }}
        onChange={(ev, item) => {
          validateSelection(ev, item, true)
        }}
        onSearch={searchValue => {
          if (!searchValue) {
            setSearchValue(null);
          } else {
            setSearchValue(searchValue);
          }
        }}
      />
    </div>
  );
}

const mstp = ({ authentication, logout }) => ({ authentication, logout });

export default connect(mstp)(AjaxSelect);
